import { BankDetailsFormFields } from './types';

/**
 * Дефолтные реквизиты банка используемый
 * при созданнии нового банковского реквизита
 */
export class DefaultBankDetails implements BankDetailsFormFields {
  public id: string = `new-bank-details-${Math.random()}`;
  public bankName: string = '';
  public bankAddress: string = '';
  public currentAccount: string = '';
  public correspondentAccount: string = '';
  public currency: string = "";
  public bik: string = '';
  public swift: string = '';
  public defaultDetails: boolean = false;
}
